import TechStackGroup from "./TechStackGroup";

const TechStackRightSummary = ({
  techStacks,
  isDay,
  siteTheme,
  profileSummaries,
}) => {
  return (
    <div className="max-w-max-profile-content-width mx-auto px-2 md:px-0">
      <div className="flex flex-col w-full gap-10 mt-10 lg:flex-row lg:items-start ">
        <div className="flex flex-col items-center justify-center w-full lg:w-[30%]">
          <TechStackGroup data={techStacks.slice(0, 2)} />
          <TechStackGroup data={techStacks.slice(2, 5)} />
          <TechStackGroup data={techStacks.slice(5, 7)} />
          <TechStackGroup data={techStacks.slice(7, 10)} />
        </div>
        <div className="w-full px-0 md:px-5 overflow-hidden lg:w-[70%]">
          <div className="relative flex items-center justify-start w-full">
            <div className="w-1/2 sm:w-2/3 md:w-1/3 flex-nowrap">
              <p
                className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-semibold font-saira`}
              >
                Techstack Summary
              </p>
            </div>
            <div
              className={`w-1/2 sm:w-3/4 md:w-2/3 h-[0.5px] bg-gradient-to-r from-linesLight to-transparent absolute right-0`}
            />
          </div>
          <div className="mt-10 lg:ml-10">
            <p
              className={`${
                isDay ? siteTheme.textColor : "text-neutral-400"
              } font-light text-[14px] tracking-[0.08em] leading-loose mb-10 font-saira`}
            >
              {profileSummaries.first}
            </p>
          </div>
        </div>
      </div>
      <div className="w-full px-0 md:px-5 lg:px-0 overflow-hidden md:mt-10">
        <p
          className={`${
            isDay ? siteTheme.textColor : "text-neutral-400"
          } font-light text-[14px] tracking-[0.08em] leading-loose mb-10 font-saira`}
        >
          {profileSummaries.third}
        </p>
        <p
          className={`${
            isDay ? siteTheme.textColor : "text-neutral-400"
          } font-light text-[14px] tracking-[0.08em] leading-loose font-saira`}
        >
          {profileSummaries.fourth}
        </p>
      </div>
    </div>
  );
};

export { TechStackRightSummary };
export default TechStackRightSummary;
